import React, { useEffect } from 'react';

const CommandPaletteItem = ({ 
    dataIndex,
    isSelected, 
    icon, 
    title, 
    subtitle, 
    extraSubtitle,
    matchHints,
    badge,
    secondBadge,
    onClick, 
    onMouseEnter 
}) => {
    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') return;
        if (!matchHints?.length) return;
        console.log(
          `[searchHighlight][CommandPaletteItem] render Trouvé lines\n${JSON.stringify(
            {
              title: typeof title === 'string' ? title : '(react node)',
              matchHints,
            },
            null,
            2
          )}`
        );
    }, [matchHints, title]);

    return (
        <div className="px-2">
            <div
                data-index={dataIndex}
                className={`flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors rounded-lg ${
                    isSelected 
                        ? 'bg-gray-100 text-gray-900' 
                        : 'text-gray-700 hover:bg-gray-200'
                }`}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
            >
                {/* Icon */}
                <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center ${
                    isSelected ? 'bg-gray-200' : 'bg-gray-100'
                }`}>
                    {icon}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                    <div className={`text-sm font-medium truncate ${
                        isSelected ? 'text-gray-900' : 'text-gray-700'
                    }`}>
                        {title}
                    </div>
                    {subtitle && (
                        <div className="text-xs text-gray-500 truncate [&_strong]:text-gray-900 [&_strong]:font-bold [&_strong]:bg-yellow-50">
                            {subtitle}
                        </div>
                    )}
                    {extraSubtitle && (
                        <div className="text-xs text-gray-500 truncate [&_strong]:text-gray-900 [&_strong]:font-bold [&_strong]:bg-yellow-50">
                            {extraSubtitle}
                        </div>
                    )}
                    {matchHints?.map((hint) => (
                        <div key={hint} className="text-xs italic text-gray-500 truncate">
                            {hint}
                        </div>
                    ))}
                </div>

                {/* Badges */}
                <div className="flex-shrink-0 flex gap-1 min-w-0 max-w-[220px]">
                    {badge && (
                        <span className={`px-2 py-0.5 text-xs font-medium rounded-md truncate [&_strong]:font-bold [&_strong]:bg-yellow-50 ${
                            isSelected 
                                ? 'bg-gray-200 text-gray-700' 
                                : 'bg-gray-100 text-gray-600'
                        }`}>
                            {badge}
                        </span>
                    )}
                    {secondBadge && (
                        <span className={`px-2 py-0.5 text-xs font-medium rounded-md ${
                            isSelected 
                                ? 'bg-yellow-200 text-yellow-800' 
                                : 'bg-yellow-100 text-yellow-700'
                        }`}>
                            {secondBadge}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CommandPaletteItem;
